// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-collapse-container[data-v-3638b34a] {\n  padding: 10px 0;\n}", ""]);
// Exports
module.exports = exports;
